// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BgJqjFRr7VU03tPmjTfB {
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 2rem 3rem;
  overflow-x: hidden;
}
.BgJqjFRr7VU03tPmjTfB h2 {
  padding: 0;
  font-size: 2rem;
  color: hsl(249, 68%, 15%);
  margin: 0;
}
@media (min-width: 900px) {
  .BgJqjFRr7VU03tPmjTfB h2 {
    padding-left: 3rem;
  }
}
.BgJqjFRr7VU03tPmjTfB h2 .Y5ZT56WYeQDN12MDzR0J {
  text-decoration: overline hsl(232, 100%, 64%);
  font-size: 1em;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI {
  display: none;
}
@media (min-width: 900px) {
  .BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI {
    display: flex;
  }
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI {
  flex-direction: column;
  gap: 1rem;
  text-align: right;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI a {
  text-decoration: none;
  font-weight: 600;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI a:hover {
  text-decoration: underline;
  text-underline-offset: 0.2rem;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI .JVf1TNuEewuPyOIYynxT .ljAs7ioqkyWkIDdHwBYP {
  color: gray;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI .JVf1TNuEewuPyOIYynxT .ljAs7ioqkyWkIDdHwBYP a {
  color: hsl(232, 100%, 64%);
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI ._XG8HMyX_nYqsHIHXLJA {
  display: flex;
  flex-direction: row;
  gap: 2rem;
}
.BgJqjFRr7VU03tPmjTfB .k4cmKJgtmfhwFSIJZeDI ._XG8HMyX_nYqsHIHXLJA a {
  color: hsl(249, 68%, 15%);
}

.PoPqFFTgHYAgCShPTZXE {
  display: grid;
  grid-template-rows: 1fr 1fr;
}
@media (min-width: 900px) {
  .PoPqFFTgHYAgCShPTZXE {
    grid-template-columns: 1fr 1fr;
  }
}
.PoPqFFTgHYAgCShPTZXE {
  height: 100vh;
  overflow: hidden;
}

.G83oO4wE5PigglrEjlrA {
  position: relative;
  margin-right: 1rem;
}
@media (min-width: 900px) {
  .G83oO4wE5PigglrEjlrA {
    margin-left: 4rem;
    margin-right: 2rem;
  }
}
.G83oO4wE5PigglrEjlrA .Td2rJZTjJnChr0ukieNG {
  display: flex;
  flex-direction: row;
  position: relative;
}
@keyframes U9xxws36zuLOKBAVpwEN {
  from {
    top: 0;
  }
  100% {
    top: -50%;
  }
}
.G83oO4wE5PigglrEjlrA .Td2rJZTjJnChr0ukieNG {
  animation: U9xxws36zuLOKBAVpwEN 30s linear infinite;
}
@media (min-width: 900px) {
  .G83oO4wE5PigglrEjlrA .Td2rJZTjJnChr0ukieNG:hover {
    animation-play-state: paused;
  }
}
.G83oO4wE5PigglrEjlrA .r8rjBf1NFLsmUuJ79o3w, .G83oO4wE5PigglrEjlrA .VujJzqdVphy5IzOSat6Q {
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
}
.G83oO4wE5PigglrEjlrA .RyAyfyv32B54uTSw2Z4e {
  width: 100%;
  margin: 0.5rem 0;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 400ms ease-in-out;
  overflow: hidden;
}
.G83oO4wE5PigglrEjlrA .RyAyfyv32B54uTSw2Z4e img {
  width: 100%;
  padding: 0;
  transition: transform 400ms ease-in-out;
  transform: scale(1.13);
}
.G83oO4wE5PigglrEjlrA .RyAyfyv32B54uTSw2Z4e:hover {
  transform: scale(1.04);
}
.G83oO4wE5PigglrEjlrA .RyAyfyv32B54uTSw2Z4e:hover img {
  transform: scale(1);
}
.G83oO4wE5PigglrEjlrA .lIdUEs5vlGJkiuq1SZaI {
  top: 0;
  height: 200px;
  width: 100%;
  position: absolute;
  opacity: 0.7;
  background: linear-gradient(white, transparent);
  pointer-events: none;
}

.ey4gDyvY1JzEcr7f5Ezj {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: hsl(249, 68%, 15%);
  position: absolute;
  margin: 0;
  width: 100vw;
  height: 100vh;
  align-items: center;
}
@media (min-width: 900px) {
  .ey4gDyvY1JzEcr7f5Ezj {
    position: inherit;
    margin-left: 2rem;
    margin-right: 1rem;
    width: inherit;
    max-width: 70%;
  }
}
.ey4gDyvY1JzEcr7f5Ezj .aXZ2LtDfkt89KSEAeukY {
  background-color: white;
  border-radius: 5px;
  width: 80%;
  min-height: 50%;
  font-size: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
@media (min-width: 900px) {
  .ey4gDyvY1JzEcr7f5Ezj .aXZ2LtDfkt89KSEAeukY {
    width: 100%;
    height: 100%;
    align-items: flex-start;
    font-size: 0.8rem;
  }
}
.ey4gDyvY1JzEcr7f5Ezj p {
  font-size: 2em;
  text-align: center;
}
@media (min-width: 900px) {
  .ey4gDyvY1JzEcr7f5Ezj p {
    text-align: left;
  }
}
.ey4gDyvY1JzEcr7f5Ezj h1 {
  font-size: 4.4em;
}
.ey4gDyvY1JzEcr7f5Ezj h1 .ZstMINyuYMyeStAlnD2e {
  font-size: 1em;
  text-decoration: underline hsl(232, 100%, 64%);
  text-underline-offset: 0.2em;
}
.ey4gDyvY1JzEcr7f5Ezj a {
  color: white;
  background-color: hsl(232, 100%, 64%);
  text-decoration: none;
  font-weight: 500;
  border-radius: 100px;
  transition: transform 200ms ease-in-out;
  text-align: center;
  padding: 14px 20px;
  margin: 2rem 0;
}
@media (min-width: 900px) {
  .ey4gDyvY1JzEcr7f5Ezj a {
    padding: 1.125em 1.5em;
    margin: 0;
  }
}
.ey4gDyvY1JzEcr7f5Ezj a:hover {
  background-color: hsl(249, 68%, 15%);
  transform: translateY(-0.2em);
}`, "",{"version":3,"sources":["webpack://./src/header/index.module.scss","webpack://./src/scss/colors.scss","webpack://./src/scss/media.scss"],"names":[],"mappings":"AAGA;EACC,kBAAA;EACA,MAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;AAFD;AAGC;EACC,UAAA;EACA,eAAA;EACA,yBChBQ;EDiBR,SAAA;AADF;AEfC;EFYA;IAME,kBAAA;EACD;AACF;AAAE;EACC,6CAAA;EACA,cAAA;AAEH;AACC;EACC,aAAA;AACF;AE3BC;EFyBA;IAGE,aAAA;EAGD;AACF;AAPC;EAKC,sBAAA;EACA,SAAA;EACA,iBAAA;AAKF;AAJE;EACC,qBAAA;EACA,gBAAA;AAMH;AALG;EACC,0BAAA;EACA,6BAAA;AAOJ;AAHG;EACC,WAAA;AAKJ;AAJI;EACC,0BC7CO;ADmDZ;AAFE;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAIH;AAHG;EACC,yBCvDM;AD4DV;;AACA;EACC,aAAA;EACA,2BAAA;AAED;AEhEC;EF4DD;IAIE,8BAAA;EAIA;AACF;AATA;EAMC,aAAA;EACA,gBAAA;AAMD;;AAHA;EACC,kBAAA;EACA,kBAAA;AAMD;AE9EC;EFsED;IAIE,iBAAA;IACA,kBAAA;EAQA;AACF;AAPC;EACC,aAAA;EACA,mBAAA;EACA,kBAAA;AASF;AARE;EACC;IACC,MAAA;EAUF;EARC;IACC,SAAA;EAUF;AACF;AApBC;EAYC,mDAAA;AAWF;AEpGC;EF0FC;IAEE,4BAAA;EAYF;AACF;AATC;EACC,aAAA;EACA,sBAAA;EACA,iBAAA;AAWF;AATC;EACC,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;EACA,gBAAA;AAWF;AAVE;EACC,WAAA;EACA,UAAA;EACA,uCAAA;EACA,sBAAA;AAYH;AAVE;EACC,sBAAA;AAYH;AAXG;EACC,mBAAA;AAaJ;AATC;EACC,MAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,+CAAA;EACA,oBAAA;AAWF;;AAPA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBC1IS;ED2IT,kBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAUD;AExJC;EFoID;IAYE,iBAAA;IACA,iBAAA;IACA,kBAAA;IACA,cAAA;IACA,cAAA;EAYA;AACF;AAXC;EACC,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAaF;AE7KC;EFsJA;IAYE,WAAA;IACA,YAAA;IACA,uBAAA;IACA,iBAAA;EAeD;AACF;AAbC;EACC,cAAA;EACA,kBAAA;AAeF;AEzLC;EFwKA;IAIE,gBAAA;EAiBD;AACF;AAfC;EACC,gBAAA;AAiBF;AAhBE;EACC,cAAA;EACA,8CAAA;EACA,4BAAA;AAkBH;AAfC;EACC,YAAA;EACA,qCCzLU;ED0LV,qBAAA;EACA,gBAAA;EACA,oBAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AAiBF;AEjNC;EFuLA;IAWE,sBAAA;IACA,SAAA;EAmBD;AACF;AAlBE;EACC,oCCvMO;EDwMP,6BAAA;AAoBH","sourcesContent":["@use \"../scss/colors\";\n@use \"../scss/media.scss\" as *;\n\n.navbar {\n\tposition: absolute;\n\ttop: 0;\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\twidth: 100%;\n\tpadding: 2rem 3rem;\n\toverflow-x: hidden;\n\th2 {\n\t\tpadding: 0;\n\t\tfont-size: 2rem;\n\t\tcolor: colors.$primary;\n\t\tmargin: 0;\n\t\t@include on-desktop {\n\t\t\tpadding-left: 3rem;\n\t\t}\n\t\t.overline {\n\t\t\ttext-decoration: overline colors.$secondary;\n\t\t\tfont-size: 1em;\n\t\t}\n\t}\n\t.rows {\n\t\tdisplay: none;\n\t\t@include on-desktop {\n\t\t\tdisplay: flex;\n\t\t}\n\t\tflex-direction: column;\n\t\tgap: 1rem;\n\t\ttext-align: right;\n\t\ta {\n\t\t\ttext-decoration: none;\n\t\t\tfont-weight: 600;\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t\ttext-underline-offset: .2rem;\n\t\t\t}\n\t\t}\n\t\t.row1 {\n\t\t\t.contact {\n\t\t\t\tcolor: gray;\n\t\t\t\ta {\n\t\t\t\t\tcolor: colors.$secondary;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.row2 {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tgap: 2rem;\n\t\t\ta {\n\t\t\t\tcolor: colors.$primary;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.content {\n\tdisplay: grid;\n\tgrid-template-rows: 1fr 1fr;\n\t@include on-desktop {\n\t\tgrid-template-columns: 1fr 1fr;\n\t}\n\theight: 100vh;\n\toverflow: hidden;\n}\n\n.imagesContainer {\n\tposition: relative;\n\tmargin-right: 1rem;\n\t@include on-desktop {\n\t\tmargin-left: 4rem;\n\t\tmargin-right: 2rem;\n\t}\n\t.images {\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tposition: relative;\n\t\t@keyframes up {\n\t\t\tfrom {\n\t\t\t\ttop: 0;\n\t\t\t}\n\t\t\t100% {\n\t\t\t\ttop: -50%;\n\t\t\t}\n\t\t}\n\t\tanimation: up 30s linear infinite;\n\t\t&:hover {\n\t\t\t@include on-desktop {\n\t\t\t\tanimation-play-state: paused;\n\t\t\t}\n\t\t}\n\t}\n\t.col1, .col2 {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tmargin-left: 1rem;\n\t}\n\t.imageContainer {\n\t\twidth: 100%;\n\t\tmargin: .5rem 0;\n\t\tborder-radius: 10px;\n\t\tcursor: pointer;\n\t\ttransition: transform 400ms ease-in-out;\n\t\toverflow: hidden;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t\tpadding: 0;\n\t\t\ttransition: transform 400ms ease-in-out;\n\t\t\ttransform: scale(1.13);\n\t\t}\n\t\t&:hover {\n\t\t\ttransform: scale(1.04);\n\t\t\timg {\n\t\t\t\ttransform: scale(1);\n\t\t\t}\n\t\t}\n\t}\n\t.gradient {\n\t\ttop: 0;\n\t\theight: 200px;\n\t\twidth: 100%;\n\t\tposition: absolute;\n\t\topacity: .7;\n\t\tbackground: linear-gradient(white, transparent);\n\t\tpointer-events: none;\n\t}\n}\n\n.textcontent {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tcolor: colors.$primary;\n\tposition: absolute;\n\tmargin: 0;\n\twidth: 100vw;\n\theight: 100vh;\n\talign-items: center;\n\t@include on-desktop {\n\t\tposition: inherit;\n\t\tmargin-left: 2rem;\n\t\tmargin-right: 1rem;\n\t\twidth: inherit;\n\t\tmax-width: 70%;\n\t}\n\t.textContentInner {\n\t\tbackground-color: white;\n\t\tborder-radius: 5px;\n\t\twidth: 80%;\n\t\tmin-height: 50%;\n\t\tfont-size: .6rem;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tpadding: 1rem;\n\t\t@include on-desktop {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\talign-items: flex-start;\n\t\t\tfont-size: .8rem;\n\t\t}\n\t}\n\tp {\n\t\tfont-size: 2em;\n\t\ttext-align: center;\n\t\t@include on-desktop {\n\t\t\ttext-align: left;\n\t\t}\n\t}\n\th1 {\n\t\tfont-size: 4.4em;\n\t\t.ul {\n\t\t\tfont-size: 1em;\n\t\t\ttext-decoration: underline colors.$secondary;\n\t\t\ttext-underline-offset: .2em;\n\t\t}\n\t}\n\ta {\n\t\tcolor: white;\n\t\tbackground-color: colors.$secondary;\n\t\ttext-decoration: none;\n\t\tfont-weight: 500;\n\t\tborder-radius: 100px;\n\t\ttransition: transform 200ms ease-in-out;\n\t\ttext-align: center;\n\t\tpadding: 14px 20px;\n\t\tmargin: 2rem 0;\n\t\t@include on-desktop {\n\t\t\tpadding: 1.125em 1.5em;\n\t\t\tmargin: 0;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground-color: colors.$primary;\n\t\t\ttransform: translateY(-.2em);\n\t\t}\n\t}\n}\n","$primary: hsl(249, 68%, 15%);\n$secondary: hsl(232, 100%, 64%);\n$ternary: hsl(221, 66%, 94%);\n\n$dark: hsl(250, 73%, 12%);\n","@mixin on-desktop {\n\t@media (min-width: 900px) {\n\t\t@content;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar": `BgJqjFRr7VU03tPmjTfB`,
	"overline": `Y5ZT56WYeQDN12MDzR0J`,
	"rows": `k4cmKJgtmfhwFSIJZeDI`,
	"row1": `JVf1TNuEewuPyOIYynxT`,
	"contact": `ljAs7ioqkyWkIDdHwBYP`,
	"row2": `_XG8HMyX_nYqsHIHXLJA`,
	"content": `PoPqFFTgHYAgCShPTZXE`,
	"imagesContainer": `G83oO4wE5PigglrEjlrA`,
	"images": `Td2rJZTjJnChr0ukieNG`,
	"up": `U9xxws36zuLOKBAVpwEN`,
	"col1": `r8rjBf1NFLsmUuJ79o3w`,
	"col2": `VujJzqdVphy5IzOSat6Q`,
	"imageContainer": `RyAyfyv32B54uTSw2Z4e`,
	"gradient": `lIdUEs5vlGJkiuq1SZaI`,
	"textcontent": `ey4gDyvY1JzEcr7f5Ezj`,
	"textContentInner": `aXZ2LtDfkt89KSEAeukY`,
	"ul": `ZstMINyuYMyeStAlnD2e`
};
export default ___CSS_LOADER_EXPORT___;
